
import React, { useEffect, useRef ,useState} from 'react';
import videojs from 'video.js';
import { DatePicker } from 'antd';
import 'video.js/dist/video-js.css';
import { Button, Modal } from 'antd';
import Main from "../components/layout/Main";
import back from '../assets/images/back.svg';
import Header from "../components/layout/Header";
import { Space, Slider, Input, Tag, Dropdown } from 'antd';
import { get, post } from "../Libraries/Ajax/HttpService";

import {
    ReconciliationOutlined, FieldTimeOutlined, SwapOutlined,
    DashboardOutlined, ArrowLeftOutlined, ArrowDownOutlined, DownOutlined, EditOutlined, CloseOutlined, CheckOutlined, DeleteOutlined, BugOutlined
} from '@ant-design/icons';
import {

    XAxis,
    YAxis,
    CartesianGrid,
    LineChart,
    Legend,
    Tooltip,
    Line,
    Label,
    Bar,
    BarChart,Area,
    ComposedChart,
    ResponsiveContainer,

} from "recharts";


const VideoPlayer = () => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const progressRef = useRef(null); 
  const [weekday, setWeekday] = useState(["Weekday"]);
  const [selectedDate, setselectedDate] = useState("");
  const [srcUrl, setsrcUrl] = useState("https://d1s4th28aykoif.cloudfront.net/24hourVideo.mp4");
  const [floor1, setfloor1] = useState("10");
  const [floor2, setfloor2] = useState("20");
  const [floor3, setfloor3] = useState("34");
  const [SliderValue, setSliderValue] = useState("20");
  const [parkingdata, setParkingData] = useState("34");
  const [color, setColor] = useState([]);
  

//   const { RangePicker } = DatePicker;

const radioChanges = event => {
    setWeekday(event.target.id);
};

const onChangeDate = (date, dateString) => {
    console.log("sachin")
    console.log(date,'----------', dateString);
    setselectedDate(dateString)
  };

 

  const data = {
    "1": {"f1": 84, "f2": 17, "f3": 113, "f4": 20, "f5": 80},
    "2": {"f1": 101, "f2": 22, "f3": 42, "f4": 90, "f5": 30},
    "3": {"f1": 56, "f2": 37, "f3": 75, "f4": 10, "f5": 110},
    "4": {"f1": 29, "f2": 12, "f3": 94, "f4": 70, "f5": 40},
    "5": {"f1": 113, "f2": 17, "f3": 101, "f4": 50, "f5": 100},
    "6": {"f1": 67, "f2": 82, "f3": 36, "f4": 30, "f5": 70},
    "7": {"f1": 16, "f2": 17, "f3": 17, "f4": 80, "f5": 20},
    "8": {"f1": 41, "f2": 22, "f3": 59, "f4": 40, "f5": 90},
    "9": {"f1": 70, "f2": 17, "f3": 7, "f4": 100, "f5": 60},
    "10": {"f1": 95, "f2": 12, "f3": 31, "f4": 60, "f5": 10},
    "11": {"f1": 19, "f2": 17, "f3": 52, "f4": 20, "f5": 50},
    "12": {"f1": 109, "f2": 52, "f3": 95, "f4": 110, "f5": 30},
    "13": {"f1": 112, "f2": 47, "f3": 22, "f4": 70, "f5": 80},
    "14": {"f1": 97, "f2": 12, "f3": 67, "f4": 10, "f5": 40},
    "15": {"f1": 53, "f2": 87, "f3": 86, "f4": 30, "f5": 90},
    "16": {"f1": 79, "f2": 62, "f3": 20, "f4": 80, "f5": 20},
    "17": {"f1": 32, "f2": 17, "f3": 89, "f4": 50, "f5": 100},
    "18": {"f1": 45, "f2": 22, "f3": 115, "f4": 70, "f5": 70},
    "19": {"f1": 110, "f2": 17, "f3": 112, "f4": 90, "f5": 30},
    "20": {"f1": 103, "f2": 92, "f3": 10, "f4": 40, "f5": 90},
    "21": {"f1": 74, "f2": 17, "f3": 119, "f4": 100, "f5": 60},
    "22": {"f1": 24, "f2": 52, "f3": 23, "f4": 20, "f5": 50},
    "23": {"f1": 78, "f2": 47, "f3": 56, "f4": 110, "f5": 30},
    "24": {"f1": 64, "f2": 12, "f3": 38, "f4": 70, "f5": 80}
  };



  
  const handleSliderChange = (value) => {
    const values = String(value)
    console.log(values)
    // Update the state variable with the new slider value
    setSliderValue(values);
    setfloor1(data[values]["f1"])
    setfloor2(data[values]["f2"])
    setfloor3(data[value].f3)
    

  };

  const data2 = [
    {
      name: 'Floor 1',
      uv: 590,
      pv: 800,
      amt: 1400,
    },
    {
      name: 'Floor 2',
      uv: 868,
      pv: 967,
      amt: 1506,
    },
    {
      name: 'Floor 3',
      uv: 1397,
      pv: 1098,
      amt: 989,
    },
    {
      name: 'Floor 4',
      uv: 1480,
      pv: 1200,
      amt: 1228,
    },
    {
      name: 'Floor 5',
      uv: 1520,
      pv: 1108,
      amt: 1100,
    },
    {
      name: 'Floor 6',
      uv: 1400,
      pv: 680,
      amt: 1700,
    },
  ];


  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    get(`apis/user_color?user_id=${userid}`)
        .then(response => {

            console.log(response.data.color);
            setColor(response.data.color);

        });
}, []);



  useEffect(() => {
    // Initialize Video.js player
    playerRef.current = videojs(videoRef.current, {
      // Video.js options
      controls: true,
      autoplay: true,
      preload: 'auto',
    });

    // Add event listener for timeupdate to update the progress bar
    playerRef.current.on('timeupdate', () => {
      if (progressRef.current) {
        const currentTime = playerRef.current.currentTime();
        const duration = playerRef.current.duration();
        const percentage = (currentTime / duration) * 100;
        progressRef.current.style.width = `${percentage}%`;
      }
    });

    // Clean up on unmount
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
      }
    };
    
  }, []);


  const handlePlayButtonClick = () => {
    if (playerRef.current) {
      if (playerRef.current.paused()) {
        playerRef.current.play();
      } else {
        playerRef.current.pause();
      }
    }
  };

  return (
    <>
    {/* <head>
      <title>{window.location.href.indexOf("mizuwatch.com") > -1 ? "MizuWatch" : "MizuSmart"}  </title></head> */}
      <Header />
    <Main>
    <div className="waterDetails">
      <div className="d-flex justify-content-between mb-4">
          <div className="d-flex fs-30 gap-3">
          {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
          <img src={back} alt="" style={{width:'10px', cursor: 'pointer'}}   />
          <h3 className="mb-0">Parking</h3>
          </div>
          <div className="selectCalender py-2 videoDate">
          <DatePicker onChange={onChangeDate}  separator={<SwapOutlined />} /> 
          </div>
      </div>
{/* 
        <div className="selectCalender py-2">

        <DatePicker onChange={onChangeDate}  separator={<SwapOutlined />} /> 
        </div> */}

        </div>
    <div className="d-flex justify-content-center">
      {/* Video.js player */}
      <video ref={videoRef} className="video-js" >
        <source src={srcUrl} type="video/mp4" />
      </video>



      {/* <button  type="primary" size="small" style={{  width: 90, }} onClick={handlePlayButtonClick}>
        Play
      </button> */}

      {/* Custom progress bar */}
      {/* <div className="progress-container">
        <div className="progress" ref={progressRef}></div>
      </div> */}
    </div>


    <div className="col-12 col-lg-12 water-chartLists bg-white" style={{borderRadius: '16px;'}}>
          {/* <div className="days-waters" >
            <div class="form-check d-flex mb-2 align-items-center">
                <Input className="form-check-input" type="radio" id="Weekday" name="day" onChange={radioChanges} defaultChecked={true} />
                <label className="form-check-label" for="day1">
                    Weekdays
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Weekend" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day2">
                    Weekends
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Sundays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day3">
                    Sunday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Mondays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day4">
                    Monday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Tuesdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day5">
                    Tuesday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Wednesdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day6">
                    Wednesday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Thursdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day7">
                    Thursday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Fridays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day8">
                    Fridays
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Saturdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day9">
                    Saturday
                </label>
            </div>
        </div> */}

        {/* ----- */}
        <div style={{ width: '50%', float: 'left' }}>
            <br/>
            <br/>
            <br/>
            <br/>
            <Slider value={floor3} tooltip={{ open: true }} max={120}   />
            <br/>
            <br/><br/>
            <br/>
            <br/>
            <Slider value={floor2} tooltip={{ open: true }} max={120}   />
            <br/>
            <br/><br/>
            <br/>
            <br/>
            <Slider value={floor1} tooltip={{ open: true }} max={120} style={{ height: '30px' }}  />
            <br/>
            <br/><br/>
            <br/>
            <br/>
            <Slider defaultValue={SliderValue} max={24}  onChange={handleSliderChange} tooltip={{ open: true }} />
            <br/>
            <br/><br/>
            <br/>
            <br/>
            <h4> Hour</h4>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            
        </div>
















/















{/* 
        <BarChart id="canvas"
            width={1200}
            height={300}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            data={[]}
        >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" interval={0} angle={0} dx={20} />
            <YAxis />
            <Tooltip />
        </BarChart> */}
        {/* -------------------------------------------------- */}
        {/* <ComposedChart
          layout="vertical"
          width={1500}
          height={800}
          data={data2}
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" scale="band" />
          <Tooltip />
          <Legend />
        
          <Bar dataKey="pv" barSize={6} background={{ fill: "#FF0000"  }} fill="#0000FF">
           
          </Bar>
         
        </ComposedChart> */}
      

    </div>
    </Main>
    </>
  );
};

export default VideoPlayer;
